export default "__VITE_ASSET__DARqyte___"